import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import React, { Fragment, useState } from "react";
import Grid from "@mui/material/Grid";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import { ValidatorForm } from 'react-material-ui-form-validator';
import { TextValidator } from 'react-material-ui-form-validator';
import Typography from "@mui/material/Typography";
import FeedbackTabButtonsViewModel from "../ViewModels/FeedbackTabButtonsViewModel";

interface IQATeamLeaderChallengeAcceptDialog {
    open: boolean;
    close(): void;
    acceptFeedbackChallenge: (reason: string) => void;
    feedback: FeedbackTabButtonsViewModel;
}

export default function QATeamLeaderChallengeAcceptDialog(props: IQATeamLeaderChallengeAcceptDialog) {
    const [reason, setReason] = useState<string | null>(null);
    const [otherReason, setOtherReason] = useState<string>("");
    const reasons = ['QA Error', 'TL/Ops Error', 'Other'];

    const handleReasonChange = (event: any) => {
        setReason(event.target.value);
    }

    const handleOtherReasonChange = (event: any) => {
        setOtherReason(event.target.value);
    }

    const handleClose = () => {
        setReason(null);
        setOtherReason("");
        props.close();
    }

    const handleConfirm = () => {
        if (reason) {
            if (reason !== 'Other') {
                props.acceptFeedbackChallenge(reason);
            }
            else {
                props.acceptFeedbackChallenge(otherReason);
            }
        }
        handleClose();
    }

    return (
        <Dialog
            open={props.open}
            maxWidth={'sm'}
            fullWidth
        >
            <DialogTitle variant="h5">
                {
                    props.feedback.deleteOnChallengeUpheld &&
                    <Typography variant="h4" marginBottom={7}>Accepting this challenge will delete this feedback</Typography>
                }
                What is the reason for accepting this feedback challenge?
            </DialogTitle>
            <ValidatorForm onSubmit={handleConfirm}>
                <Grid container alignItems="flex-end">
                    <Grid container justifyContent="flex-end" alignItems="flex-end" size={12} spacing={1}>
                        <Grid size={6}>
                            <FormControl fullWidth>
                                <InputLabel>Reason</InputLabel>
                                <Select
                                    fullWidth
                                    label="Reason"
                                    value={reason}
                                    onChange={handleReasonChange}
                                >
                                    {
                                        reasons.map((reason, index) =>
                                            <MenuItem
                                                key={index}
                                                value={reason}>
                                                {reason}
                                            </MenuItem>)
                                    }
                                </Select>
                            </FormControl>
                        </Grid>
                        {
                            reason === "Other" &&
                            <Fragment>
                                <Grid size={6} />
                                <Grid size={12}>
                                    <TextValidator
                                        fullWidth
                                        variant="outlined"
                                        label="Other Reason*"
                                        autoComplete="off"
                                        value={otherReason}
                                        onChange={handleOtherReasonChange}
                                        multiline
                                        validators={['required', 'maxStringLength:100',]}
                                        errorMessages={['This field is required', '100 character limit']}

                                    />
                                </Grid>
                            </Fragment>
                        }
                        <Grid size={3}>
                            <Button
                                fullWidth
                                variant="contained"
                                color="secondary"
                                onClick={() => handleClose()}>
                                Cancel
                            </Button>
                        </Grid>
                        <Grid size={3}>
                            <Button
                                fullWidth
                                variant="contained"
                                color="primary"
                                disabled={!reason}
                                type="submit"
                            >
                                Confirm
                            </Button>
                        </Grid>
                    </Grid>
                </Grid>
            </ValidatorForm>
        </Dialog>
    );
}